import { useScopedI18n, useCurrentLocale } from '@/locales/client'
import { getBaseUrl } from '../utils/url-helpers'

export function useFooter() {
  const t = useScopedI18n('common.links')
  const locale = useCurrentLocale()

  const PRODUCTS_LINKS: { label: string; link: string }[] = [
    {
      label: t('carInsurance'),
      link: getBaseUrl('', locale),
    },
    {
      label: t('health_sme'),
      link: getBaseUrl('/health-sme', locale),
    },
    {
      label: t('medicalMalpractice'),
      link: getBaseUrl('/mmp', locale),
    },
    {
      label: t('domesticHelper'),
      link: getBaseUrl('/domestic-helper', locale),
    },
    {
      label: t('travel'),
      link: getBaseUrl('/travel', locale),
    },
    {
      label: t('home'),
      link: getBaseUrl('/home', locale),
    },
    {
      label: t('premiumResidency'),
      link: getBaseUrl('/premium-residency', locale),
    },
    {
      label: t('protectionAndSaving'),
      link: getBaseUrl('/ps', locale),
    },
    {
      label: t('marine'),
      link: getBaseUrl('/marine', locale),
    },
    // ...(appEnv !== 'Production'
    //   ? [{ link: '/civil-liability', label: t('civilLiability') }]
    //   : []),
  ]

  const RESOURCES_LINKS: { label: string; link: string }[] = [
    {
      label: t('faq'),
      link: `/${locale}/faq`,
    },
    {
      label: t('blog'),
      link: 'https://blog.tameeni.com/',
    },
    {
      label: t('insuranceAuthority'),
      link: getBaseUrl('/compliance-policy-center', locale),
    },
    {
      label: t('partners'),
      link: getBaseUrl('/partners', locale),
    },
    {
      label: t('careers'),
      link: getBaseUrl('/career', locale),
    },
  ]

  const SUPPORT_LINKS: { label: string; link: string }[] = [
    {
      label: t('contactus'),
      link: getBaseUrl('/contact-us', locale),
    },
    {
      label: t('privacy'),
      link: getBaseUrl('/privacy-policy', locale),
    },
    {
      label: t('terms'),
      link: getBaseUrl('/terms-and-conditions', locale),
    },
  ]

  // Create menu items based on current structure
  const menuItems = [
    {
      label: t('products'),
      items: PRODUCTS_LINKS,
    },
    {
      label: t('support'),
      items: SUPPORT_LINKS,
    },
    {
      label: t('resources'),
      items: RESOURCES_LINKS,
    },
  ]

  return {
    menuItems,
  }
}
